import { motion } from "framer-motion";

const PROOF_PHOTO =
  "https://customer-assets.emergentagent.com/job_sircs-community/artifacts/5rc74j7w_73EDA18D-4D5D-4574-8D48-6B12B9E82ED2.png";

const STATS = [
  { value: "9", label: "Miembros fundadores", note: "Comunidad privada · cupos limitados" },
  { value: "24/7", label: "Conversación activa", note: "Discusiones reales, no contenido vacío" },
  { value: "01", label: "Operador principal", note: "Santi Lorenzo · acompañamiento directo" },
];

const TESTIMONIES = [
  {
    text:
      "Por primera vez identifico el bucle antes de meterme en él. SIRCS no enseña, hace que veas.",
    author: "M. — miembro fundador",
  },
  {
    text: "Pensaba que era falta de disciplina. Era programación. Y se puede reescribir.",
    author: "Á. — miembro fundador",
  },
];

export default function SocialProof() {
  return (
    <section
      id="prueba"
      data-testid="proof-section"
      className="surface-light relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-12">
          <span className="h-px w-10 bg-taupe/60" />
          <span className="font-body text-[11px] tracking-[0.28em] uppercase text-taupe">
            05 · Voces
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-20">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-cream-soft rounded-2xl border border-taupe/15 p-8 lg:p-10 flex flex-col justify-between min-h-[220px]"
              data-testid={`proof-stat-${i}`}
            >
              <div className="font-display text-7xl sm:text-8xl font-normal tracking-[-0.03em] leading-none text-ink">
                {s.value}
              </div>
              <div className="mt-8">
                <div className="font-display text-2xl text-ink">{s.label}</div>
                <div className="font-body text-[11px] uppercase tracking-[0.24em] text-taupe mt-2">
                  {s.note}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -14 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4 relative"
          >
            <div className="relative aspect-[3/4] overflow-hidden rounded-[8px] bg-ink shadow-[0_25px_60px_-20px_rgba(20,17,13,0.4)]">
              <img src={PROOF_PHOTO} alt="Santi Lorenzo" className="w-full h-full object-cover" />
              <div
                className="absolute inset-0 pointer-events-none mix-blend-soft-light"
                style={{
                  background:
                    "radial-gradient(50% 40% at 65% 25%, rgba(201,168,106,0.30), transparent 60%)",
                }}
              />
            </div>
          </motion.div>

          <div className="lg:col-span-8 space-y-5">
            {TESTIMONIES.map((t, i) => (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`proof-testimony-${i}`}
                className="bg-cream-soft rounded-2xl border border-taupe/15 p-8 lg:p-10"
              >
                <div className="font-body text-[10px] uppercase tracking-[0.28em] text-warm mb-5">
                  Transmisión · {String(i + 1).padStart(2, "0")}
                </div>
                <blockquote className="font-display text-2xl sm:text-3xl leading-snug text-ink">
                  «{t.text}»
                </blockquote>
                <figcaption className="mt-6 font-body text-[11px] uppercase tracking-[0.24em] text-taupe">
                  {t.author}
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
